export default {
      id: "unlink-usage",
      viewBox: "-3 0 24 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#unlink",
      toString: function () {
        return this.url;
      }
    }